import type { TodoItem } from '@amumin/api-client';

import { api } from '../api.js';
import { writePref } from './ui.js';

// Oprichter 6 okt 2026: je eigen to-do's staan in Mijn omgeving (0053), alleen jij ziet ze. Hier de
// weg erheen (en terug naar een gezin) zonder dat Vandaag de pagina Mijn to-do's hoeft te laden.

/** Taken onthoudt zijn weergave in deze browser (pages/Tasks.tsx); zo opent hij op To-do. */
export const TODO_VIEW = { key: 'fb.tasks.view', value: 'todo' } as const;

/**
 * Naar Mijn omgeving (of met een id naar dat gezin) en daar Taken › To-do. Een andere omgeving laadt
 * de pagina opnieuw: alle caches en open editors weg, net als bij de omgevingswissel in de schil.
 */
export async function openTodosIn(householdId: 'personal' | string): Promise<void> {
  if (householdId === 'personal') await api.app.auth.personalSpace();
  else await api.app.household.switch(householdId);
  writePref(TODO_VIEW.key, TODO_VIEW.value);
  window.location.assign('/taken');
}

const OPEN_STATES: ReadonlySet<string> = new Set(['open', 'pending', 'rejected']);

/**
 * De open to-do's voor de kaart op Vandaag, in de volgorde van de API (belangrijk eerst). In het
 * gezin alleen die van jouw lid (zonder eigen lid: alle); in Mijn omgeving ben jij de enige.
 */
export function myOpenTodos(
  items: ReadonlyArray<TodoItem>,
  o: { personal: boolean; me: string | null },
): TodoItem[] {
  return items.filter(
    (i) => OPEN_STATES.has(i.state) && (o.personal || !o.me || i.member_id === o.me),
  );
}
